import React from 'react';
import Footer from './Footer';
import HeroBanner from './HeroBanner';

interface PolicyLayoutProps {
  title: string;
  image?: string;
  children: React.ReactNode;
}

const PolicyLayout: React.FC<PolicyLayoutProps> = ({ title, image = '/images/fhome-honey-pour.jpg', children }) => {
  return (
    <div className="goto-here" style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      <HeroBanner image={image}>
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs">
              <span className="mr-2"><a href="/">Home</a></span> <span>{title}</span>
            </p>
            <h1 className="mb-0 bread">{title}</h1>
          </div>
        </div>
      </HeroBanner>

      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="p-4 p-md-5 bg-white shadow-sm rounded">
                {children}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PolicyLayout;
